import { Component, inject, signal } from '@angular/core';
import { BatchJobScheduleComponent } from './batch-job-schedule/batch-job-schedule.component';
import { BatchJobStatusComponent } from './batch-job-status/batch-job-status.component';
import { BatchJobComponent } from './batch-job/batch-job.component';
import { BatchSearchComponent } from './batch-search/batch-search.component';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { BatchService } from './batch.service';
import { BatchJobScheduleDetailComponent } from './batch-job-schedule-detail/batch-job-schedule-detail.component';
import { AuthService } from '@core/auth/auth.service';
import { RettighedsType } from '@core/auth/rettighed.model';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';

@Component({
  selector: 'app-batch',
  imports: [
    BatchJobScheduleComponent,
    BatchJobComponent,
    BatchSearchComponent,
    BatchJobStatusComponent,
    Button,
    Dialog,
    BatchJobScheduleDetailComponent,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
  ],
  templateUrl: './batch.component.html',
  styleUrl: './batch.component.css',
})
export class BatchComponent {
  authService = inject(AuthService);
  batchService = inject(BatchService);
  showOpret = signal(false);

  opretBatchjob() {
    this.batchService.selectedBatchJobSchedule.set(undefined);
    this.showOpret.set(true);
  }

  onHideOpretJob() {
    this.batchService.batchJobDatasource.loadData();
    this.batchService.batchJobSceduleDatasource.loadData();
  }

  allowEdit() {
    return this.authService.hasRettighed(RettighedsType.AdminBatchSkriv);
  }
}
